"use client";

import Link from "next/link";

import { cn } from "@/lib/utils/utils";
import { pad2 } from "@/lib/blog/format";

import { useBlogReader } from "../BlogReaderProvider";

/**
 * The desktop reading bar.
 *
 * Carries the document progress and the section counter. Hidden below lg,
 * where `BlogMobileIndex` renders the same three facts in a narrower bar that
 * also opens the contents sheet.
 */
const BlogStickyBar = () => {
  const { toc, sectionLabel, active, progress, started } = useBlogReader();

  if (toc.length === 0) return null;

  return (
    <div
      aria-hidden={!started}
      className={cn(
        "sticky top-0 z-30 hidden border-b border-rule bg-background/92 backdrop-blur-[10px] transition-[opacity,transform] duration-500 ease-[cubic-bezier(.22,.61,.36,1)] lg:block",
        started
          ? "translate-y-0 opacity-100"
          : "pointer-events-none -translate-y-2 opacity-0",
      )}
    >
      <div className="h-[3px] w-full bg-rule">
        <div
          className="h-[3px] w-full origin-left bg-ink transition-transform duration-150 ease-linear"
          style={{ transform: `scaleX(${progress})` }}
        />
      </div>

      <div className="mx-auto flex w-full max-w-360 flex-wrap items-center justify-between gap-4 px-10 py-3.5">
        <div className="flex min-w-0 items-center gap-3">
          <span className="text-[15px] font-bold tracking-[-0.01em] text-ink">
            OCTARNAL
          </span>
          <span className="text-sm text-ink-mute">/</span>
          <Link href="/blogs" className="text-sm text-ink-soft hover:text-ink">
            Journal
          </Link>
        </div>

        <p className="text-[13px] tracking-[0.04em] text-ink-soft uppercase">
          {sectionLabel}{" "}
          <span className="font-semibold text-ink tabular-nums">
            {pad2(active)}
          </span>{" "}
          / {pad2(toc.length)}
        </p>

        <p className="text-[13px] text-ink-mute tabular-nums">
          {Math.round(progress * 100)}% read
        </p>
      </div>
    </div>
  );
};

export default BlogStickyBar;
